import { Logger } from '~~/helpers/logger';
import { errorToString } from '~~/helpers/error/errorToString';
import { useCtStoreApi } from '~/utils/ct/composables/api/useCtStoreApi';
import type { ApiParams, StoresData, StoresWhereSearch } from '~~/types/commercetools';

export function useCtStore() {

  const { load: apiLoad } = useCtStoreApi();

  const response = useState<StoresData | null>('useCtStore-response', () => null);
  const loading = useState<boolean>('useCtStore-loading', () => false);
  const error = useState<{
    load: null | string,
  }>('useCtStore-error', () => ({
    load: null,
  }));

  async function load(params: ApiParams<StoresWhereSearch>) {

    Logger.debug('useCtStore.load', params);
    error.value.load = null;
    try {

      loading.value = true;
      response.value = await apiLoad(params);
    
    } catch (err) {

      error.value.load = errorToString(err);
      Logger.error('useCtStore.load', err);
    
    } finally {

      loading.value = false;
    
    }
  
  }

  return {
    load,
    response: computed(() => response.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
  };

}
